<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item>广告</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form :model='queryParams' ref='queryForm' size='small' :inline='true' v-show='showSearch'>
                            <el-form-item style='margin-bottom: 0' label='广告状态' prop='status'>
                                <el-select
                                    v-model='queryParams.advertType'
                                    placeholder='请选择广告状态'
                                    clearable
                                    style='width: 240px'
                                >
                                    <el-option
                                        v-for='advert in queryParams.advertStatus'
                                        :key='advert.label'
                                        :label='advert.label'
                                        :value='advert.value'
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button type='primary' icon='el-icon-search' size='mini' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4'>
                        <el-row style="float: right; margin-right: 20px" :gutter='10' class='mb8'>
                            <el-col :span='1.5'>
                                <el-button
                                    type='primary'
                                    plain
                                    icon='el-icon-plus'
                                    size='mini'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table :cell-style="{ textAlign: 'center' }" v-loading='loading' :data='advertList'>
                <el-table-column type='expand' align='center' prop='id' >
                    <template slot-scope='props'>
                        <el-descriptions :column='1' :colon='false' title="广告详情">
                            <el-descriptions-item label-class-name="advertItemLabel" content-class-name="advertItemContent" label="标题">{{props.row.title}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="advertItemLabel" content-class-name="advertItemContent" label="内容">{{props.row.content}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="advertItemLabel" content-class-name="advertItemContent" label="样式">{{props.row.style}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="advertItemLabel" content-class-name="advertItemContent" label="标签">{{props.row.tag}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="advertItemLabel" content-class-name="advertItemContent" label="链接">
                                <span @click='copyUrl(props.row.url)'>{{props.row.url}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label-class-name="advertItemLabel" content-class-name="advertItemContent" label="图片">
                                <template slot='label'>
                                    <div class='advert-image-box'>
                                        <el-image fit='contain' :previewSrcList='[props.row.imagePath]' :src='props.row.imagePath'>
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </div>
                                </template>
                            </el-descriptions-item>
                        </el-descriptions>
                    </template>
                </el-table-column>
                <el-table-column label='广告id' align='center' prop='id' />
                <el-table-column label='标题' align='center' prop='title' :show-overflow-tooltip='true' />
                <el-table-column label='版本' align='center' prop='version' :show-overflow-tooltip='true'/>
                <el-table-column label='点击后id' align='center' prop='clickId' :show-overflow-tooltip='true'>
                    <template slot-scope='scope'>
                        <span>{{scope.row.clickId}}</span>
                    </template>
                </el-table-column>
                <el-table-column label='是否激活' align='center' prop='createTime' width='180'>
                    <template slot-scope='scope'>
                        <el-switch size='mini' @change='handleChangeAdvertStatus(scope.row)' :active-value='1' :inactive-value='0' v-model='scope.row.isActive'/>
                    </template>
                </el-table-column>
                <el-table-column label='是否点击' align='center' prop='createTime' width='180'>
                    <template slot-scope='scope'>
                        <el-switch size='mini' @change='handleChangeAdvertStatus(scope.row)' :active-value='1' :inactive-value='0' v-model='scope.row.isClick'/>
                    </template>
                </el-table-column>
                <el-table-column label='操作' align='center' class-name='small-padding fixed-width'>
                    <template slot-scope='scope'>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='500px' append-to-body>
                <el-form ref="form" :model="currentAdvert" label-width="100px" size="mini">
                    <el-form-item label="广告标题">
                        <el-input v-model='currentAdvert.title'/>
                    </el-form-item>
                    <el-form-item label="样式">
                        <el-input v-model='currentAdvert.style' placeholder='请输入广告样式'/>
                    </el-form-item>
                    <el-form-item label="标签">
                        <el-input v-model='currentAdvert.tag' placeholder='请输入广告标签'/>
                    </el-form-item>
                    <el-form-item label="链接">
                        <el-input v-model='currentAdvert.url' placeholder='请输入链接'/>
                    </el-form-item>
                    <el-form-item label='宽、高'>
                        <el-row :gutter='10'>
                            <el-col :span='8'>
                                <el-input type='number' v-model='currentAdvert.width'>
                                    <template slot='prefix'>
                                        宽
                                    </template>
                                </el-input>
                            </el-col>
                            <el-col :span='8'>
                                <el-input type='number' v-model='currentAdvert.height'>
                                    <template slot='prefix'>
                                        高
                                    </template>
                                </el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="版本号">
                        <el-input type='number' v-model='currentAdvert.version' placeholder='请输入链接'/>
                    </el-form-item>
                    <el-form-item label="点击后广告Id">
                        <el-select :clearable='true' v-model='currentAdvert.clickId'>
                            <el-option v-for='(item, index) in advertList' :key='index' :label='item.title' :value='item.id' />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="内容">
                        <el-input type='textarea' placeholder='请输入广告内容' :autosize='{minRows: 2, maxRows: 10}' v-model='currentAdvert.content'/>
                    </el-form-item>
                    <el-form-item label="图片">
                        <el-tabs v-model='imagePathTabActive'>
                            <el-tab-pane label='手动输入' name='inputImage'>
                                <el-input v-model='currentAdvert.imagePath' placeholder='请输入图片地址' />
                            </el-tab-pane>
                            <el-tab-pane label='图片上传' name='upload'>
                                <el-upload
                                    ref='imageUpload'
                                    class="upload-demo"
                                    drag
                                    accept='.jpg'
                                    action='""'
                                    :auto-upload='false'
                                    :on-change='handleFile'
                                    :before-remove='handleRemoveFile'
                                    :file-list='uploadFileList'>
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                    <div class="el-upload__tip" slot="tip">只能上传jpg文件，且不超过2M</div>
                                </el-upload>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deleteAdvert, getAllAdvert, insertAdvice, modifyAdviceById } from '@/components/api/advert';
import upload from '@/components/page/projects/Upload.vue';
import { copyContent } from '@/utils/string/cottonPlugin';
import { deepCopy } from '@/utils/object';
import { isImageSrc } from '@/utils/regex/regexUtils.js';
import { REGEXP_URL } from '@/constant/regexEnums';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';

export default {
    name: 'Dict',
    computed: {
        upload() {
            return upload
        }
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 显示搜索条件
            showSearch: true,
            advertList: [],
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 1,
                pageNum: 1,
                pageSize: 15,
                id: undefined,
                advertType: undefined,
                advertStatus: [
                    {
                        label: '关闭',
                        value: 0
                    },
                    {
                        label: '开启',
                        value: 1
                    }
                ],
                projectName: undefined
            },
            // 表单校验
            rules: {
                name: [
                    { required: true, message: '项目组名称不能为空', trigger: 'blur' }
                ],
                projectId: [
                    { required: true, message: '项目组不能缺项目', trigger: 'blur' }
                ],
                roleId: [
                    { required: true, message: '项目组不能缺角色', trigger: 'blur' }
                ]
            },
            updateStatus: false,
            // 所有项目
            projectDataList: [
            
            ],
            currentAdvert: {},
            imagePathTabActive: 'inputImage',
            uploadFileList: []
        };
    },
    created() {
        this.getList();
    },
    methods: {
        copyUrl(url) {
            copyContent(url, false)
        },
        handleClickParentId(parentAdvert) {
            if (parentAdvert.clickId) {
                this.queryParams.id = parentAdvert.clickId
                this.getList()
            }
        },
        setImageNatureInfo(src) {
            // 获取上传的图片元素
            const imgElement = new Image();
            if (src && REGEXP_URL.test(src) && isImageSrc(src)) {
                imgElement.src = src
            }else {
                imgElement.src = URL.createObjectURL(src);
            }
            // 在图片加载完成后获取原始高度和宽度
            imgElement.onload = () => {
                const originalWidth = imgElement.width;
                const originalHeight = imgElement.height;
                this.$set(this.currentAdvert, 'width', originalWidth)
                this.$set(this.currentAdvert, 'height', originalHeight)
            };
        },
        handleFile(file) {
            if (this.$refs.imageUpload.uploadFiles && this.$refs.imageUpload.uploadFiles.length > 1) {
                message.warning("只能上传一张图片，请先移除其余图片")
                this.$refs.imageUpload.uploadFiles.forEach((k, index) => {
                    if (k.name === file.name) {
                        this.$refs.imageUpload.uploadFiles.splice(this.$refs.imageUpload.uploadFiles.indexOf(k), 1)
                    }
                })
                return;
            }
            let fileSize = (file.size / 1024 / 1024).toFixed(2)
            if (fileSize > 2) {
                message.warning("图片太大了")
                this.uploadFileList = []
                return
            }
            if (file.raw.type !== 'image/jpeg') {
                message.warning("请上传jpg格式")
                this.uploadFileList = []
                return
            }
            this.currentAdvert.file = file.raw
            this.setImageNatureInfo(file.raw)
        },
        handleRemoveFile(file, fileList) {
            this.currentAdvert.file = undefined
            return true
        },
        handleChangeAdvertStatus(data) {
            modifyAdviceById(data).then(result => {
                if (result.code === 200) {
                    message.success("修改成功")
                    return
                }
            })
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum
            this.getList()
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            const param = this.queryParams;
            getAllAdvert({projectName: this.queryParams.projectName, type: this.queryParams.advertType, id: this.queryParams.id}).then(result => {
                if (result.code === 200) {
                    this.advertList = result.data.records
                    this.queryParams.total = result.data.total
                    this.queryParams.pageSize = result.data.size
                    this.queryParams.pageNum = result.data.current
                    this.loading = false
                }
            })
            
            queryProjectInfoList({pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.projectDataList = result.data
                }
            })
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {}
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.currentAdvert = {}
            this.open = true;
            this.title = '添加广告';
            this.updateStatus = false
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改广告信息';
            this.updateStatus = true
            this.currentAdvert = deepCopy(row)
            this.$refs.imageUpload.uploadFiles = []
        },
        handleDelete(row) {
            let obj = this
            this.$modal.confirm('是否确认删除广告"' + row.title + '"的数据项？').then(function() {
                return deleteAdvert(row);
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    obj.$modal.msgSuccess('删除成功');
                }
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                modifyAdviceById(this.currentAdvert).then(result => {
                    if (result.code === 200) {
                        message.success("修改成功")
                        this.open = false
                        this.getList()
                        this.uploadFileList = []
                        return
                    }
                })
            }else {
                insertAdvice(this.currentAdvert).then(result => {
                    if (result.code === 200) {
                        message.success("添加成功")
                        this.getList()
                        this.open = false
                        this.uploadFileList = []
                    }
                })
            }
        },
    },
    watch: {
        'currentAdvert.imagePath': function(newValue) {
            if (isImageSrc(newValue)) {
                this.setImageNatureInfo(newValue)
            }
        }
    }
};
</script>
<style lang='css'>
.advertItemLabel {
    font-weight: bold;
}
.advertItemContent {
    margin-bottom: .1rem;
}
.advert-image-box {
    height: 10rem;
    width: 10rem;
}
</style>